import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { observer } from "mobx-react-lite";
import { Navigate, useNavigate } from "react-router-dom";

import { fontSize, Stack } from "@mui/system";
import { Check, KeyboardArrowDown } from "@mui/icons-material";

import store from "../../mobx";
import MixQuickBrandText from "../../components/BrandText/MixQuickBrandText";
import zIndex from "@mui/material/styles/zIndex";
import { useState } from "react";
import { firestore } from "../../services/firebase";
import { STRIPE_PRODUCT_ID_MAP, STRIPE_PRODUCTS } from "../../constants";

export const MixQuickProductCard = observer(function MixQuickProductCard() {
  const [hovering, setHovering] = useState(false);
  const { isPhone } = store.mediaBreakpointStore;

  const navigate = useNavigate();

  const ownsProduct =
    store.userStore.profile?.products?.MixQuickClipper?.purchased === true;

  return (
    <Stack alignItems="center" justifyContent={"center"}>
      {ownsProduct ? (
        <ProductCard />
      ) : (
        <Typography>{`You don't own any products`}</Typography>
      )}
    </Stack>
  );
});

function ProductCard() {
  return (
    <Stack direction={"row"} sx={{ maxWidth: 350 }}>
      <Card
        sx={{
          bgcolor: "#222",
          border: "1px solid #aaa",
          borderRadius: 4,
        }}
      >
        <CardContent>
          <CardText
            sx={{
              pointerEvents: "none",
            }}
          />
          <List>
            <ListItem>
              <ListItemText
                primary="Version"
                secondary="0.0.1 (Early Access)"
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="Purchased"
                secondary={store.userStore.profile.products.MixQuickClipper.updated
                  .toDate()
                  .toDateString()}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="License"
                secondary={
                  store.userStore.profile.products.MixQuickClipper.license
                }
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary="Lifetime Upgrades"
                secondary={String(
                  store.userStore.profile.products.MixQuickClipper
                    .lifetimeUpgrades
                )}
              />
            </ListItem>
          </List>
        </CardContent>
        <CardActions>
          <Stack direction={"row"} sx={{ marginLeft: "auto" }} spacing={2}>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                firestore.doc.update({
                  path: `users/${store.userStore.session.uid}`,
                  data: {
                    [`products.${STRIPE_PRODUCTS.products.MixQuickClipper.name}`]:
                      firestore.deleteField(),
                  },
                });
              }}
            >
              Delete
            </Button>
            <Button
              variant="contained"
              color="altPrimary"
              sx={{ color: "black" }}
              onClick={() =>
                window.open(
                  "https://firebasestorage.googleapis.com/v0/b/last-year-18294.firebasestorage.app/o/Mix.Quick.vst3.zip?alt=media"
                )
              }
            >
              Download
            </Button>
          </Stack>
        </CardActions>
      </Card>
    </Stack>
  );
}

function CardText({ sx }) {
  return (
    <Box sx={sx}>
      <MixQuickBrandText sx={{ fontSize: 48 }} />
      <Box
        sx={{
          height: "4px", // thickness of the underline
          width: "33%",
          borderRadius: 2,
          background: "linear-gradient(to right, orange, transparent)", // gradient colors
          mt: 2,
          mb: 2,
        }}
      />
      <Box mb={2} />
    </Box>
  );
}
